import { useState, useEffect } from 'react';
import { Grid, Typography, Button, Chip } from '@mui/material';

// SERVICES
import { getIncidencias } from '../../services/catalogo_incidencias/getDatosIncidencias';

// ICONOS
import AddIcon from '@mui/icons-material/Add';

// COMPONENTES
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import AgregarIncidencia from './modales/AgregarIncidencia';
import EditarIncidencia from './modales/EditarIncidencia';

const CatalogoIncidencias = () => {

    // =========================================
    // ESTADOS PARA DATOS
    // =========================================

    const [incidencias, setIncidencias] = useState([]);

    const getData = async () => {

        const incidenciasResponse = await getIncidencias();

        setIncidencias(incidenciasResponse);

    }

    // =========================================
    // COLUMNAS
    // =========================================

    const columns = [

        { 
            field: 'reason', 
            headerName: 'Descripcion',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'severity', 
            headerName: 'Prioridad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'is_active', 
            headerName: 'Status',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.is_active === 1 ? <Chip label='Activo' color='success' /> : <Chip label='Inactivo' color='error' />
        },

    ];

    // =========================================
    // ESTADOS PARA MODAL
    // =========================================

    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);

    // =========================================
    // FUNCION PARA SELECCIONAR FILA
    // =========================================

    const [selected, setSelected] = useState({
        descripcion: '',
        severity: ''
    });

    const selectRow = ( params ) => {

        setSelected(params.row);
        setShowModalEdit(true);

    }

    // =========================================
    // USE  EFFECT PARA OBTENER DATOS
    // =========================================

    useEffect(() => {

        getData();

    }, []);

    // =========================================

    return (

        <Grid container>

            {/* TITULO */}

            <Grid size={6} marginBottom={2}>

                <Typography
                    variant="h5"
                    fontWeight={700}
                >
                    Catalogo de Incidencias
                </Typography>

            </Grid>

            {/* BOTONES */}

            <Grid 
                size={6} 
                marginBottom={2}
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end' 
                }}
            >

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setShowModal(true)}
                    sx={{
                        backgroundColor: 'black'
                    }}
                >
                    Agregar Incidencia
                </Button>

            </Grid>

            {/* TABLA */}

            <Grid size={12}>

                <MiTabla
                    columns={columns}
                    data={incidencias}
                    onRowClick={selectRow}
                />

            </Grid>

            {/* MODAL AGREGAR INCIDENCIAS */}

            <AgregarIncidencia
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={getData}
                data={selected}
            />

            {/* MODAL EDITAR INCIDENCIAS */}

            <EditarIncidencia
                open={showModalEdit}
                onClose={() => setShowModalEdit(false)}
                refresh={getData}
                data={selected}
            />

        </Grid>

    )

}

export default CatalogoIncidencias